import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsxs("svg", {
	baseProfile: "tiny",
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	overflow: "visible",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3.7,5.7c-1.4,1.4-1.4,3.6,0,5c0.7,0.7,1.6,1,2.5,1s1.8-0.3,2.5-1c1.4-1.4,1.4-3.6,0-5C7.3,4.3,5.1,4.3,3.7,5.7z M7.4,9.3 c-0.6,0.6-1.6,0.6-2.3,0S4.5,7.6,5.1,7c0.3-0.3,0.7-0.5,1.1-0.5C6.6,6.5,7,6.7,7.4,7C8,7.6,8,8.7,7.4,9.3z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.1,11.7c1.1,0,2.2-0.4,2.9-1.2c1.6-1.6,1.6-4.3,0-5.9c0,0,0,0,0,0c-0.8-0.8-1.8-1.2-2.9-1.2c-1.1,0-2.2,0.4-2.9,1.2 c-1.6,1.6-1.6,4.3,0,5.9C15,11.2,16,11.7,17.1,11.7z M15.5,5.9c0.4-0.4,1-0.7,1.6-0.7s1.2,0.2,1.6,0.7c0.9,0.9,0.9,2.3,0,3.2 c-0.8,0.8-2.3,0.8-3.2,0C14.7,8.2,14.7,6.8,15.5,5.9z" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.1,13.6h-3.9c-2.7,0-4.8,2.2-4.8,4.8v1.3c0,0.5,0.4,1,1,1s1-0.4,1-1v-1.3c0-1.6,1.3-2.9,2.9-2.9h3.9 c1.6,0,2.9,1.3,2.9,2.9v1.3c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-1.3C23.9,15.8,21.7,13.6,19.1,13.6z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.5,13.6H4.9c-2.7,0-4.8,2.2-4.8,4.8v1.3c0,0.5,0.4,1,1,1s1-0.4,1-1v-1.3c0-1.6,1.3-2.9,2.9-2.9h2.6c0.5,0,1-0.4,1-1 S8,13.6,7.5,13.6z" })
	]
});
export default SvgPeople;
